// extracted by mini-css-extract-plugin
export var section = "hero-module--section--1vUlC";
export var inner = "hero-module--inner--D4K3X";
export var headWrap = "hero-module--headWrap--3wFnI";